import classNames from 'classnames';
import React from 'react';

// The LevelUp wordmark, one path per letter: L-e-v-e-l-U-p.
const LETTER_PATHS = [
	'M6 32.7809V8H11.9895V27.9167H22.2988V32.7809H6Z',
	'M34.0873 33.1318C32.1432 33.1318 30.4653 32.7487 29.0536 31.9823C27.65 31.2079 26.5691 30.1068 25.8108 28.679C25.0606 27.2431 24.6855 25.537 24.6855 23.5607C24.6855 21.6408 25.0646 19.9629 25.8229 18.5271C26.5812 17.0831 27.65 15.9618 29.0294 15.1632C30.4088 14.3566 32.0343 13.9532 33.9058 13.9532C35.2287 13.9532 36.4387 14.1589 37.5358 14.5703C38.6329 14.9817 39.5807 15.5908 40.3793 16.3974C41.1779 17.2041 41.799 18.2003 42.2427 19.3862C42.6864 20.5639 42.9082 21.9151 42.9082 23.4397V24.9159H26.7546V21.4795H37.4027C37.3946 20.8503 37.2454 20.2896 36.955 19.7976C36.6646 19.3055 36.2653 18.9223 35.7571 18.6481C35.2569 18.3657 34.6802 18.2245 34.0268 18.2245C33.3653 18.2245 32.7724 18.3738 32.2481 18.6723C31.7237 18.9627 31.3083 19.362 31.0017 19.8702C30.6952 20.3703 30.5339 20.939 30.5177 21.5763V25.0732C30.5177 25.8315 30.667 26.497 30.9654 27.0697C31.2639 27.6344 31.6874 28.074 32.236 28.3886C32.7845 28.7032 33.4379 28.8605 34.1962 28.8605C34.7205 28.8605 35.1964 28.7879 35.624 28.6427C36.0515 28.4975 36.4185 28.2837 36.7251 28.0014C37.0316 27.7191 37.2615 27.3722 37.4148 26.9608L42.8477 27.1181C42.6218 28.3362 42.1257 29.3969 41.3594 30.3004C40.6011 31.1958 39.6049 31.8936 38.3707 32.3937C37.1365 32.8858 35.7087 33.1318 34.0873 33.1318Z',
	'M63.4602 14.1952L57.0834 32.7809H50.3074L43.9428 14.1952H50.1743L53.5986 26.9971H53.7922L57.2286 14.1952H63.4602Z',
	'M73.8178 33.1318C71.8737 33.1318 70.1959 32.7487 68.7842 31.9823C67.3806 31.2079 66.2996 30.1068 65.5414 28.679C64.7912 27.2431 64.4161 25.537 64.4161 23.5607C64.4161 21.6408 64.7952 19.9629 65.5535 18.5271C66.3117 17.0831 67.3806 15.9618 68.76 15.1632C70.1394 14.3566 71.7648 13.9532 73.6363 13.9532C74.9592 13.9532 76.1692 14.1589 77.2663 14.5703C78.3634 14.9817 79.3112 15.5908 80.1098 16.3974C80.9084 17.2041 81.5296 18.2003 81.9732 19.3862C82.4169 20.5639 82.6387 21.9151 82.6387 23.4397V24.9159H66.4852V21.4795H77.1332C77.1252 20.8503 76.9759 20.2896 76.6855 19.7976C76.3951 19.3055 75.9958 18.9223 75.4876 18.6481C74.9875 18.3657 74.4107 18.2245 73.7573 18.2245C73.0958 18.2245 72.5029 18.3738 71.9786 18.6723C71.4543 18.9627 71.0388 19.362 70.7323 19.8702C70.4258 20.3703 70.2644 20.939 70.2483 21.5763V25.0732C70.2483 25.8315 70.3975 26.497 70.696 27.0697C70.9945 27.6344 71.418 28.074 71.9665 28.3886C72.515 28.7032 73.1684 28.8605 73.9267 28.8605C74.451 28.8605 74.927 28.7879 75.3545 28.6427C75.782 28.4975 76.1491 28.2837 76.4556 28.0014C76.7622 27.7191 76.9921 27.3722 77.1453 26.9608L82.5782 27.1181C82.3524 28.3362 81.8563 29.3969 81.0899 30.3004C80.3317 31.1958 79.3354 31.8936 78.1012 32.3937C76.867 32.8858 75.4392 33.1318 73.8178 33.1318Z',
	'M91.5777 8V32.7809H85.6607V8H91.5777Z',
	'M103.425 8.36133L98.5482 14.0443C98.385 14.2539 98.3385 14.5103 98.4316 14.7666C98.5482 14.9997 98.7811 15.1627 99.0374 15.1627H101.973L101.974 25.2526C101.974 25.6255 102.277 25.9283 102.649 25.9283H106.82C107.193 25.9283 107.496 25.6253 107.496 25.2526V15.1161H110.432C110.689 15.1161 110.922 14.9529 111.038 14.72C111.085 14.6269 111.108 14.5336 111.108 14.4404C111.108 14.2772 111.061 14.1374 110.945 13.9976L106.033 8.36133H114.853C114.853 8.36133 115.129 25.1048 114.853 26.2027C114.578 27.3007 112.383 33.0648 104.697 33.0648C97.0118 33.0648 94.8151 27.3007 94.5415 26.2027C94.2679 25.1048 94.5415 8.36133 94.5415 8.36133H103.425Z',
	'M117.305 39.7506V14.1952H123.162V17.3775H123.343C123.585 16.8129 123.928 16.2684 124.372 15.744C124.824 15.2197 125.396 14.7922 126.09 14.4614C126.792 14.1226 127.631 13.9532 128.607 13.9532C129.898 13.9532 131.104 14.292 132.225 14.9696C133.354 15.6472 134.266 16.6919 134.959 18.1035C135.653 19.5152 136 21.3141 136 23.5002C136 25.6056 135.665 27.3682 134.996 28.7879C134.334 30.2076 133.439 31.2724 132.309 31.9823C131.188 32.6922 129.942 33.0471 128.571 33.0471C127.635 33.0471 126.824 32.8939 126.138 32.5873C125.453 32.2808 124.876 31.8774 124.408 31.3773C123.948 30.8772 123.593 30.3407 123.343 29.768H123.222V39.7506H117.305ZM123.101 23.4881C123.101 24.4883 123.234 25.3596 123.501 26.1017C123.775 26.8438 124.166 27.4206 124.674 27.832C125.191 28.2353 125.808 28.437 126.526 28.437C127.252 28.437 127.869 28.2353 128.377 27.832C128.885 27.4206 129.268 26.8438 129.526 26.1017C129.793 25.3596 129.926 24.4883 129.926 23.4881C129.926 22.4878 129.793 21.6206 129.526 20.8866C129.268 20.1525 128.885 19.5838 128.377 19.1805C127.877 18.7771 127.26 18.5754 126.526 18.5754C125.8 18.5754 125.183 18.7731 124.674 19.1684C124.166 19.5636 123.775 20.1283 123.501 20.8624C123.234 21.5964 123.101 22.4717 123.101 23.4881Z',
];

// The "level up" arrow cut out of the U, redrawn so it can be animated on its own.
const ARROW_PATH =
	'M103.43 8.36H106.03L111 14.1C111.12 14.3 110.95 15.12 110.43 15.12H107.5V25.25C107.5 25.64 107.2 25.93 106.82 25.93H102.65C102.28 25.93 101.97 25.64 101.97 25.25V15.16H99.04C98.4 15.1 98.35 14.4 98.55 14.04L103.43 8.36Z';

const DURATION = 3.6; // seconds per loop
const STAGGER = 0.08; // seconds between letters
const ARROW_DELAY = LETTER_PATHS.length * STAGGER;

// Letters rise in one by one, the arrow in the U lights up in brand indigo and pops out with a ripple
// and a few sparkles (a "level up"), then everything fades and the loop restarts.
const STYLE = `
@keyframes luRise {
	0% { opacity: 0; transform: translateY(14px) scale(0.92); }
	16% { opacity: 1; transform: translateY(-2px) scale(1.02); }
	24%, 86% { opacity: 1; transform: translateY(0) scale(1); }
	96%, 100% { opacity: 0; transform: translateY(-5px) scale(0.98); }
}
@keyframes luArrow {
	0%, 26% { opacity: 0; transform: translateY(6px) scale(0.6); }
	34% { opacity: 1; transform: translateY(-9px) scale(1.18); }
	44% { opacity: 1; transform: translateY(1.5px) scale(0.97); }
	50%, 86% { opacity: 1; transform: translateY(0) scale(1); }
	96%, 100% { opacity: 0; transform: translateY(-5px) scale(1); }
}
@keyframes luRipple {
	0%, 33% { opacity: 0; transform: scale(0.2); }
	36% { opacity: 0.55; transform: scale(0.4); }
	60%, 100% { opacity: 0; transform: scale(1.5); }
}
@keyframes luSpark {
	0%, 33% { opacity: 0; transform: translate(0, 0) scale(0.4); }
	40% { opacity: 1; }
	60%, 100% { opacity: 0; transform: translate(var(--dx), var(--dy)) scale(1); }
}
.lu-box { transform-box: fill-box; transform-origin: 50% 100%; }
.lu-spark, .lu-ripple { transform-box: fill-box; transform-origin: 50% 50%; }
@media (prefers-reduced-motion: reduce) {
	.lu-box, .lu-arrow { animation: none !important; opacity: 1; transform: none; }
	.lu-ripple, .lu-spark { display: none; }
}
`;

const SPARKS = [
	{ cx: 101, cy: 8, dx: -7, dy: -9 },
	{ cx: 104.7, cy: 7, dx: 0, dy: -13 },
	{ cx: 108.5, cy: 8, dx: 7, dy: -9 },
];

const LevelUpLogoLoader = ({ className }: { className?: string }) => (
	<div className={classNames('flex items-center justify-center', className)} role="status" aria-label="Loading">
		<style dangerouslySetInnerHTML={{ __html: STYLE }} />
		<svg
			viewBox="-4 -12 151 68"
			className="w-[clamp(200px,12vw,230px)] shrink-0 h-auto overflow-visible text-[#28293D] dark:text-white"
			xmlns="http://www.w3.org/2000/svg"
		>
			<defs>
				<linearGradient id="lu-arrow-grad" gradientUnits="userSpaceOnUse" x1="104.7" y1="8" x2="104.7" y2="26">
					<stop offset="0" stopColor="#8F89F5" />
					<stop offset="1" stopColor="#3027D8" />
				</linearGradient>
			</defs>

			{LETTER_PATHS.map((d, i) => (
				<path
					key={i}
					d={d}
					fill="currentColor"
					className="lu-box"
					style={{ opacity: 0, animation: `luRise ${DURATION}s cubic-bezier(0.34, 1.4, 0.64, 1) ${(i * STAGGER).toFixed(2)}s infinite` }}
				/>
			))}

			<circle
				className="lu-ripple"
				cx="104.7"
				cy="17"
				r="12"
				fill="none"
				stroke="#6161d9"
				strokeWidth="1.2"
				style={{ opacity: 0, animation: `luRipple ${DURATION}s ease-out ${ARROW_DELAY.toFixed(2)}s infinite` }}
			/>
			{SPARKS.map(spark => (
				<circle
					key={spark.cx}
					className="lu-spark"
					cx={spark.cx}
					cy={spark.cy}
					r="1.3"
					fill="#8F89F5"
					style={
						{
							opacity: 0,
							'--dx': `${spark.dx}px`,
							'--dy': `${spark.dy}px`,
							animation: `luSpark ${DURATION}s ease-out ${ARROW_DELAY.toFixed(2)}s infinite`,
						} as React.CSSProperties
					}
				/>
			))}
			<path
				className="lu-box lu-arrow"
				d={ARROW_PATH}
				fill="url(#lu-arrow-grad)"
				style={{ opacity: 0, animation: `luArrow ${DURATION}s cubic-bezier(0.34, 1.4, 0.64, 1) ${ARROW_DELAY.toFixed(2)}s infinite` }}
			/>
		</svg>
	</div>
);

export default LevelUpLogoLoader;
